export default "__VITE_ASSET__BKiqlJmy__"